import React from 'react';
import Routes from 'routes';
import { ReactComponent as DashboardIcon } from 'assets/icons/nav-menu/dashboard.svg';
import { ReactComponent as ReportsIcon } from 'assets/icons/nav-menu/reports.svg';
import { ReactComponent as InvitationsIcon } from 'assets/icons/nav-menu/invitations.svg';
import { ReactComponent as DevelopersIcon } from 'assets/icons/nav-menu/developers.svg';
import { ReactComponent as SettingsIcon } from 'assets/icons/nav-menu/settings.svg';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import { UserRole } from 'globals/types';
import defaultLocales from 'globals/locales/default';
import { StyledDivider } from './NavMenu.style-elements';

export const items = [
  {
    label: defaultLocales.welcome,
    iconComponent: <DashboardIcon />,
    to: Routes.ROOT,
    availableFor: [
      UserRole.ADMIN,
      UserRole.ACCOUNTANT,
      UserRole.LEADER,
      UserRole.DEV,
      UserRole.USER,
    ],
  },
  {
    label: defaultLocales.dashboard,
    iconComponent: <DashboardIcon />,
    to: Routes.DASHBOARD,
    availableFor: [
      UserRole.ADMIN,
      UserRole.LEADER,
      UserRole.DEV,
      UserRole.USER,
    ],
  },
  {
    label: defaultLocales.reports,
    iconComponent: <ReportsIcon />,
    to: Routes.REPORTS,
    availableFor: [
      UserRole.ADMIN,
      UserRole.LEADER,
      UserRole.DEV,
      UserRole.USER,
    ],
  },
  {
    label: defaultLocales.invitations,
    iconComponent: <InvitationsIcon />,
    to: Routes.INVITATIONS,
    availableFor: [
      UserRole.ADMIN,
      UserRole.LEADER,
      UserRole.DEV,
      UserRole.USER,
    ],
  },
  {
    label: defaultLocales.developers,
    iconComponent: <DevelopersIcon />,
    to: Routes.DEVELOPERS,
    availableFor: [UserRole.ADMIN, UserRole.DEV],
  },
  {
    label: '',
    component: <StyledDivider />,
    to: Routes.ROOT,
    availableFor: [UserRole.ADMIN, UserRole.LEADER],
  },
  {
    label: defaultLocales.settings,
    iconComponent: <SettingsIcon />,
    to: Routes.SETTINGS,
    availableFor: [UserRole.ADMIN, UserRole.LEADER],
  },
  {
    label: defaultLocales.billings,
    iconComponent: <AccountBalanceWalletOutlinedIcon />,
    to: Routes.BILLINGS,
    availableFor: [UserRole.ADMIN, UserRole.ACCOUNTANT],
  },
];

export const isBillingLabel = (label: string): boolean =>
  label === defaultLocales.billings;
